import { mapGetters, mapMutations } from 'vuex';
import { storage } from '@/utils/storage';

export default {
  name: 'LangModal',
  components: {},

  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters(['languages', 'currentLanguage'])
  },
  methods: {
    ...mapMutations({
      modalClose: `app/MODAL_CLOSE`
    }),
    onClose() {
      storage.setItem('disabled_lang_modal', true);
      this.modalClose('langModal');
    },
    onChangeLanguage(code) {
      storage.setItem('disabled_lang_modal', true);
      this.modalClose('langModal');
      this.$setLanguage(code).then(() => {
        window.location.reload();
      });
    }
  }
};
